/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmOsoba extends GContentBase<SeznamAdmOsobaObj> {
        private seznamObj: SeznamAdmOsobaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmOsobaObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmOsobaNew",
                contentCaption: "jres:33000092",
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_ref}"
                },
                gridSettings: {
                    columnOrder: "nazev,zkratka,poznamka,ico,ixs_ref,login_name,jmeno,prijmeni,tit_pred,tit_za,oc,rc,mail,typ_aut_txt,poc_dni_exp,dat_exp,priz_ext,nazev_su,priz_int,dat_exp2,login_name2,typ_aut2_txt,login_name_ext,dat_od,dat_do,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmOsobaObj extends GAdmSeznamBase {
        ginsPassZak: number;
        povoleniUrovnePristupu: boolean;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmOsoba", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmOsoba",
                newRecord: isNew,
                ixs_ref: isNew == true ? null : data.ixs_ref
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenForbiddenPasswords: {
					caption: "jres:29802754",
                    icon: "fa-lock",
                    enabled: this.ginsPassZak == 1,
					run: (ev, ctx) => {
                        this.openForbiddenPasswords()
					}
                },
                actOpenFunkcniMistaOsoby: {
                    caption: "jres:33000925",
                    icon: "fa-link",
                    run: () => {
                        this.funkcniMistaOsoby();
                    }
                },
                actOpenUrovnePristupuOsoby: {
                    caption: "jres:33000693",
                    icon: "fa-link",
                    enabled: this.povoleniUrovnePristupu == true,
                    run: () => {
                        this.urovnePristupuOsoby();
                    }
                },
                actOpenSeznamAdmOsobaCertifikat: {
                    caption: "jres:29809557",
                    icon: "gi-certif",
                    run: () => {
                        this.openSeznamAdmOsobaCertifikat();
                    }
                },
                actOpenDialogDeleteUserSettings: {
                    icon: "gi-settings",
                    caption: "jres:33000864", //RC 33000864 : Smazat u�ivatelsk� nastaven� osob
                    enabled: this.dataListDescription.data_right?.Write == true,
                    run: () => {
                        this.dialogDeleteUserSettings();
                    }
                },
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*",
                {
                    favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                        { action: this.cnt.actions.actOpenForbiddenPasswords },
                        { action: this.cnt.actions.actOpenFunkcniMistaOsoby },
                        { action: this.cnt.actions.actOpenUrovnePristupuOsoby },
                        { action: this.cnt.actions.actOpenSeznamAdmOsobaCertifikat }
                    ]
                },
                {
                    favorite: true, type: "static", caption: "jres:33000783", icon: "gi-settings", children: [
                        { action: this.cnt.actions.actOpenDialogDeleteUserSettings }
                    ]
                }],
                this.createShareMenuBarActions()
            ))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDetailOnNewTab*",
                "-",
                "actOpenFunkcniMistaOsoby*",
                "actOpenUrovnePristupuOsoby*",
                "actOpenSeznamAdmOsobaCertifikat*",
                "-",
                "actOpenDialogDeleteUserSettings*"
            ])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmOsoba.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenFunkcniMistaOsoby?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenUrovnePristupuOsoby?.update({ enabled: objArr.count == 1 && this.povoleniUrovnePristupu == true })
            this.cnt.actions.actOpenSeznamAdmOsobaCertifikat?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actOpenDialogDeleteUserSettings?.update({ enabled: objArr.count > 0 && this.dataListDescription.data_right?.Write == true })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_ref}`,
                nazev: `${data.tit_pred} ${data.jmeno} ${data.prijmeni} ${data.tit_za}`
            }
        }

        private openForbiddenPasswords() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmZakazaneHeslo", { ID: "SeznamAdmZakazaneHeslo" }])
        }

        private funkcniMistaOsoby() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmFunkcniMisto", { ixs_ref: activeRow.ixs_ref })
        }

        private urovnePristupuOsoby() {
            const activeRow = this.grid.ggrid("activeRow")
            if (activeRow)
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmUrovenPristupuOsoby", { ixs_ref: activeRow.ixs_ref }], { ID: "SeznamAdmUrovenPristupuOsoby" })
        }

        private openSeznamAdmOsobaCertifikat() {
            const activeRow = this.grid.ggrid("activeRow")
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmOsobaCertifikat", { ixs: activeRow.ixs_ref, ID: "SeznamAdmOsobaCertifikat" })
        }

        private dialogDeleteUserSettings() {
            const selection: Gordic.AdmIsl.Interface.GAdmFunkcniMistoListDto[] = this.grid.ggrid("getSelection");
            if (selection.length > 0) {
                this.cnt.dialogs.showModalWindow([Gordic.Adm.WebControls.DialogDeleteUserSettings, {
                    osoby: selection.map(item => item.ixs_ref),
                    rezimDialog: Gordic.Adm.WebControls.RezimDialog.osoba
                }], {}, {
                    width: 600,
                    height: 400
                });
            }
        }
    }
}
